import request from './request';

const event = {
	async getPublishedEvent(query) {
		const response = await request.get('/app/events/published', query);
		return response;
	}
};

export default event;